import {Enum} from 'enumify';

class MainShapeType extends Enum {};

MainShapeType.initEnum([
    'Rect', 'RoundedRect', 'Rhombus', 'Circle', 'HalfCircle', 'QuarterCircle', 'Triangle', 'Trapezoid', 'Text', 'Arrow', 'Diamond'
]);

export default MainShapeType;
